module['exports'] = [
  'افغانستان',
  'البانیا',
  'الجزایر',
  'امریکی سموا',
  'اندورہ',
  'انگولا',
  'انگویلیا',
  'انتارتیکا',
  'انتیگا اور باربئدا',
  'ارجنٹاینا',
  'ارمینیا',
  'اروبا',
  'آسٹریلیلا',
  'آسٹریا',
  'آزربایجان',
  'بہامس',
  'بہرین',
  'بنگلہ دیش',
  'باربادوس',
  'بیلاروس',
  'بیلجیم',
  'بیلیز',
  'بینن',
  'برمودہ',
  'بھوٹان',
  'بولویا',
  'بوسنیا و ہرزگووینیا',
  'بوسٹوانا',
  'برازیل',
  'برونوئ داراسلام',
  'بلغاریہ',
  'برونڈی',
  'کمبوڈیا',
  'کمروین',
  'کینیڈا',
  'سینٹرل افریقی ریاست',
  'چاڈ',
  'چلے',
  'چائنا',
  'کولمبیا',
  'کومورس',
  'کانگو',
  'کوسٹا ریکا',
  'کروایشیا',
  'کوبا',
  'چک ریاست',
  'ڈینمارک',
  'جبوتی',
  'ڈومینک ریاست',
  'اکواڈور',
  'مصر',
  'ال سلوادور',
  'ایرٹریا',
  'استونیا',
  'اتھوپیا',
  'فی جی',
  'فن لینڈ',
  'فرانس',
  'گابون',
  'گامبیہ',
  'جیورجیہ',
  'جرمنی',
  'گانا',
  'جبرالٹر',
  'یونان',
  'گام',
  'واتیکن',
  'ہونڈورس',
  'ہانگ کانگ',
  'ہنگری',
  'بھارت',
  'انڈونیشیا',
  'ایران',
  'عراق',
  'آئر لینڈ',
  'اٹلی',
  'جمائکہ',
  'جاپان',
  'اْردن',
  'کازخستان',
  'کینیا',
  'کریباتی',
  'شمالی ریاست کوریا',
  'جنوبی ریاست کوریا',
  'کویت',
  'لبنان',
  'مسیڈون',
  'مدگاسکر',
  'ملاوی',
  'ملائشیا',
  'مالدیپ',
  'مالی',
  'مالٹا',
  'میکسیکو',
  'منگولیہ',
  'مراکژ',
  'میانمار',
  'نیپال',
  'نیدرلینڈ',
  'نیوزیلینڈ',
  'نیکاراگوا',
  'نائجر',
  'نییجیریا',
  'ناروے',
  'اومان',
  'اسلامی جمہوریہ پاکستان',
  'پلاوؑ',
  'فلسطین',
  'پاناما',
  'پرو',
  'فلپائن',
  'پولینڈ',
  'پرتگال',
  'پورتو ریکو',
  'قطر',
  'رومانیہ',
  'روس',
  'روانڈا',
  'سموہ',
  'سان مرینو',
  'سعودیہ عربیہ',
  'سنیگال',
  'سربیا',
  'سے شیل',
  'سنگاپور',
  'سومالیہ',
  'جنوبی افرقہ',
  'ہسپانیہ',
  'سری لنکا',
  'سوڈان',
  'سری نامپ',
  'سوازی لینڈ',
  'سویڈن',
  'سوٹزرلینڈ',
  'شام',
  'تائوان',
  'تاجکستان',
  'تنزانیہ',
  'تھائ لینڈ',
  'ٹوگو',
  'ٹونگا',
  'ٹونیسیا',
  'ترکی',
  'ترکمانستان',
  'یوگانڈا',
  'یوکرین',
  'متحدہ عرب امارات',
  'متحدہ سلطنت',
  'متحدہ ریاست امریکا',
  'یوراگوائے',
  'اْزبکستان',
  'ونیزویلا',
  'وتنام',
  'یمن',
  'زمبیا',
  'زمبابوے',
];
